import React from 'react';
import BaseApi from '../api/BaseApi.js'
import PasswordInput from './password-input.js'

export default class ResetPassScreen extends React.Component { 

    constructor(props) {
        super(props);
        this.state = {failed: false,
                      pass: '',
                      repass: '', 
                      isValid: false};
    
        this.handleChangePass = this.handleChangePass.bind(this);
        this.handleChangeRePass = this.handleChangeRePass.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangePass(event) {
        const pass = event.target.value
        const repass = this.state.repass
        const valid = this.validate(pass, repass)
        this.setState({pass: pass, isValid: valid})
    }

    handleChangeRePass(event) {
        const pass = this.state.pass
        const repass = event.target.value
        const valid = this.validate(pass, repass)
        this.setState({repass: repass, isValid: valid})
    }

    handleSubmit(event) {
        
        BaseApi.post('/passreset', {pass: this.state.pass}, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.onResetSuccess()
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    validate(pass, repass) {
        return pass.length >=8 && pass == repass
    }
    
    render () {
        return (
        <div class = "container">  
            <div class="row mt-5">
                <div class="col-md-4 mx-auto">
                    <div class="card shadow-sm">
                        <div className="card-body">
                            <h1>Установить новый пароль</h1> 
                            <form onSubmit={this.handleSubmit}>
                                <div class="form-group">
                                    <label for="password">Новый пароль:</label>
                                    <PasswordInput class="form-control" id="password" value={this.state.pass} onChange={this.handleChangePass} />
                                    <label for="repassword">Повторите:</label>
                                    <PasswordInput class="form-control" id="repassword"  value={this.state.repass} onChange={this.handleChangeRePass} />
                                    {!this.state.isValid && <div class ="mt-5"><span style={{"color": "red"}}>Пароли не совпадают или пароль не соотвествует требованиям</span></div>} 
                                </div>
                                {this.state.isValid && <button type="submit" class="btn btn-primary w-100">Установить</button>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div> )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/resetpass-screen.js